import React, { useState } from 'react'
import { Share } from '@mui/icons-material'
import { Modal } from 'antd'
import { useParams } from 'react-router-dom'

const ShareButton = ({ editMode }: { editMode: boolean }) => {
  const { uid: userId } = useParams()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const shareUrl = `https://lirari.com/share/${userId}`

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Check out this musician on Lirari',
          text: 'I found this musician profile on Lirari that you might be interested in!',
          url: shareUrl,
        })
        // Share was successful
      } catch (error) {
        // User probably cancelled the share
        console.log('Share cancelled or failed:', error)
      }
    } else {
      // Fallback for browsers that don't support the Web Share API
      setIsModalOpen(true)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        setIsModalOpen(false)
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err)
      })
  }

  return (
    <>
      {/* Share fallback modal for desktop */}
      <Modal centered open={isModalOpen} closable={true} onCancel={() => setIsModalOpen(false)} footer={null}>
        <div className="flex flex-col items-center w-full">
          <h3 className="text-lg font-medium mb-4">Share this profile</h3>

          <div className="w-full overflow-hidden mb-4 p-2 bg-gray-100 rounded-md">
            <p className="text-sm truncate">{shareUrl}</p>
          </div>

          <button
            className="bg-[#8830C7] text-white py-2 px-6 rounded-full hover:bg-[#8830C7]/90 transition-colors text-base w-full"
            onClick={copyToClipboard}
          >
            Copy Link
          </button>
        </div>
      </Modal>

      {/* Share button */}
      {editMode ? null : (
        <button
          className="p-0 flex items-center justify-center min-w-[50px] min-h-[50px] h-[50px] w-[50px] rounded-full border-none bg-white hover:bg-[#cdcdcd]/90 cursor-pointer [&>svg]:text-black mx-2 lg:absolute lg:bottom-[5px] lg:right-[120px]"
          onClick={handleShare}
          aria-label="Share profile"
        >
          <Share />
        </button>
      )}
    </>
  )
}

export default ShareButton
